//jQuery.noConflict();
//(function ($) {

    var FormValidation = {
        version: '1.0',
        author: 'CAA Digital',
        project: 'Family Membership',
        Date: 'May 2020',

        //initialization 
        init: function () {
            var context = this;

            //Global variables
            context.config = {
                blockPageError: document.querySelector('.page-error-block__details'),
                spanPageErrorCount: document.querySelector('#page_error_count')
            };

            //Call DOM invoking functions here
            context.onDomReady();
            context.eventHandlers();

        },

        onDomReady: function () {
            var context = this;

            //Load all functions

        },

        //Handle all page level events
        eventHandlers: function () {
            var context = this;
            var alreadysubmit = false;


            // Personal details page level error messages
            var errorBlock = context.config.blockPageError,
                errorCount = context.config.spanPageErrorCount,
                parsleyForm = null,
                parsleyErrorArray = {};

            if (context.config.blockPageError && window.Parsley) {

                //On Parsley form error event show the red 
                //error box and re-attach aria attributes 

                //On Parsley field validated(fires AFTER field is validated) event 
                //create an array of error fields 
                window.Parsley.on('field:validated', function (fieldInstance) {
                    var fieldId = fieldInstance.element.id;
                    if (fieldInstance.isValid()) {
                        if (parsleyErrorArray[fieldId]) {
                            delete parsleyErrorArray[fieldId];
                        }
                        return;
                    }

                    if (fieldInstance.$element[0].previousSibling.parentNode.getAttribute("class").indexOf("input__checkbox-container") >= 0) {
                        if (fieldInstance.$element[0].previousSibling.parentNode.getAttribute("class").indexOf("parsley-error") >= 0) {
                            if (!parsleyErrorArray[fieldId])
                                parsleyErrorArray[fieldId] = fieldInstance.$element;
                        }

                    }
                    else if (fieldInstance.$element[0].parentNode.getAttribute("class").indexOf("input__radio-container") >= 0) {
                        if (fieldInstance.$element[0].parentNode.getAttribute("class").indexOf("parsley-error") >= 0) {
                            if (!parsleyErrorArray[fieldId])
                                parsleyErrorArray[fieldId] = fieldInstance.$element;
                        }
                    }
                    else {
                        if (fieldInstance.$element[0].className.indexOf('parsley-error') >= 0) {
                            if (!parsleyErrorArray[fieldId])
                                parsleyErrorArray[fieldId] = fieldInstance.$element;
                        }

                    }
                });

                //On parsley form validate(fires BEFORE form is validated) event 
                //reset the error array so the error messges don't stack up 
                window.Parsley.on('form:validate', function (frmInstance) {
                    if (!parsleyForm || parsleyForm !== frmInstance.element) {

                        parsleyForm = frmInstance.element;
                        parsleyErrorArray = {};

                    }

                });

                //On parsley form validate(fires BEFORE form is validated) event 
                //append the error messages onto page
                window.Parsley.on('form:validated', function () {
                    //clear the hash so that it focuses error block every time form is submitted 
                    var errorMsgforG4A = [];

                    var errorListDiv = document.getElementById("page_error_list");
                    errorListDiv.innerHTML = "";
                    var count = 0;

                    for (var err in parsleyErrorArray) {
                        if (!parsleyErrorArray[err]) {
                            continue;
                        }
                        var errorMsgElement = null;
                        var errInputElement = parsleyErrorArray[err][0];
                        var customErrContainer = errInputElement.getAttribute("data-parsley-errors-container");
                        if (customErrContainer) {
                            errorMsgElement = document.querySelector(customErrContainer + ' li');
                        }
                        else if (errInputElement.getAttribute("type") == "radio") {
                            var inputElement = errInputElement.parentNode.parentNode.nextElementSibling.querySelector('input.radio:first-child');
                            errorMsgElement = inputElement.nextElementSibling.nextElementSibling.querySelector('span');
                        }
                        else if (errInputElement.nextElementSibling) {
                            errorMsgElement = errInputElement.nextElementSibling.querySelector('span.error-message-copy');
                        }
                        if (errorMsgElement == null)
                            errorMsgElement = errInputElement.nextElementSibling.querySelector('li');
                        if (errorMsgElement == null) {
                            var nextElement = errInputElement.nextElementSibling;
                            if (!nextElement.classList.contains('input__text-error-message'))
                                nextElement = nextElement.nextElementSibling;
                            if (nextElement != null)
                                errorMsgElement = nextElement.querySelector('span.error-message-copy')

                        }
                        if (errorMsgElement == null)
                            errorMsgElement = errInputElement.nextSibling;
                        else if (errorMsgElement != null) {
                            errorMsg = errorMsgElement.innerText;
                            if (errorMsg) {
                                count++;
                                errorListDiv.innerHTML += "<li><span>Error " + (count) + ": </span><span><a href='#" + errInputElement.id + "'>" + errorMsg + "</a></span>" + (errInputElement.hasAttribute('data-format') ? "<span> (Format: " + errInputElement.getAttribute('data-format') + ")</span>" : '') + "</li>";
                                errorMsgforG4A.push(errorMsg); //assigning error message to array variable for g4A
                               
                            }
                        }
                    }

                    var noOfErrors = count;
                    errorCount.innerHTML = noOfErrors;
                    if (noOfErrors > 0) {
                        window.location.hash = "";
                        errorBlock.classList.remove("d-none");
                        //$(".validation__summary-copy").attr("role", "alert");
                        jQuery(".validation__summary-copy").attr("aria-live", "assertive");
                        jQuery(".validation__summary-copy").attr("role", "text");
                        //Focus error block on submit 
                        window.location.hash = "#page_error_block";
                        var errorBlockFocuEle = document.getElementById('page_error_block');
                        if (errorBlockFocuEle) {
                            errorBlockFocuEle.focus();
                        }
                    }

                    //G4A error push service - Begin                    
                    let formName;
                    if (this.submitEvent && this.submitEvent.currentTarget && this.submitEvent.currentTarget.id) {
                        formName = this.submitEvent.currentTarget.id;
                    }
                    else if (this.element && this.element.id) {
                        formName = this.element.id;
                    }
                    if (formName) {
                        console.log('formName -' + formName);
                        if (errorMsgforG4A && errorMsgforG4A.length > 0) {
                            console.log(errorMsgforG4A);
                            dataLayer.push({
                                'event': 'formError',
                                'formName': formName,
                                'formError': errorMsgforG4A
                            });
                        }
                    }
                    //G4A error push service - End

                });

                //On field success event remove the aria attributes
                window.Parsley.on('field:success', function () {
                    jQuery(".validation__summary-copy").removeAttr("role", "alert");
                    jQuery(".validation__summary-copy").removeAttr("aria-live");
                });

                //On form success event hide the red error message block
                window.Parsley.on('form:success', function () {
                    this.whenValid().then(function () {
                        errorBlock.classList.add("d-none");
                        parsleyErrorArray = {};
                    });
                });
            }
        }
    };

    window.addEventListener("load", function () {
        FormValidation.init();
    });

//});